import { useWindowSize } from "@uidotdev/usehooks";
import PropTypes from "prop-types";

export const HaveALookItem = ({
  image,
  titleheader,
  title,
  bottomValue,
  paddingleft,
}) => {
  const { width } = useWindowSize();
  return (
    <div className="transition-border  transition-radius  transition-[colors,shadow ] group mt-[20px] rounded-[20px] p-[10px] duration-500 ease-in-out hover:rounded-[20px] hover:shadow-have-a-look-hover">
      <div className="relative flex gap-[20px] sm:flex-col sm:items-center ">
        <div className="relative w-[70px]">
          <div
            className={`absolute h-[70px] w-[70px] ${width > 1156 ? bottomValue : "bottom-0"} left-[2px] rounded-[70px] bg-[#EFEFEF] group-hover:hidden  mothaibaysai:hidden`}
          ></div>
          <div className="relative flex h-[72px] w-[72px] gap-[30px] rounded-[71px] bg-white shadow-have-a-look">
            <img
              className={`${paddingleft} pb-[22px] pr-[10px] pt-[10px]`}
              src={image}
              alt="Have A Look"
            />
          </div>
        </div>

        <p className="text-4 max-w-[520px] font-normal text-[#3D2E7C] lg:max-w-[820px] lgmax:max-w-[820px]">
          <strong>{titleheader}</strong>
          {title}
        </p>
      </div>
    </div>
  );
};
HaveALookItem.propTypes = {
  image: PropTypes.string,
  titleheader: PropTypes.string,
  title: PropTypes.string,
  bottomValue: PropTypes.string,
  paddingleft: PropTypes.string,
};
